import { Component, Structure } from '@wix/thunderbolt-becky-types'

const getSplitResponsiveContainerStructure = (
	container: Component,
	annotatedChildren: Array<{
		structure: Component
		pinned: boolean
	}>
): Structure => {
	const createContainer = (
		id: string,
		parentId: string,
		componentType: string,
		childrenIds: Array<string>
	): Component => {
		return {
			id,
			components: childrenIds,
			componentType,
			layout: {},
			type: 'Container',
			parent: parentId,
			styleId: '',
			metaData: {},
		}
	}

	const relativeChildren: Array<Component> = []
	const pinnedChildren: Array<Component> = []
	annotatedChildren.forEach((child) => {
		const targetArray = child.pinned ? pinnedChildren : relativeChildren
		targetArray.push(child.structure)
	})

	const relativeChildrenContainer: Component = createContainer(
		`${container.id}_relative`,
		container.id,
		'ResponsiveContainer',
		relativeChildren.map((child) => child.id)
	)

	const pinnedChildrenContainer = pinnedChildren.length
		? createContainer(
				`${container.id}_pinned`,
				container.id,
				'DynamicStructureContainer',
				pinnedChildren.map((child) => child.id)
		  )
		: undefined

	const newContainerStructure: Structure = {
		[container.id]: {
			...container,
			components: [relativeChildrenContainer.id],
		},
		[relativeChildrenContainer.id]: relativeChildrenContainer,
	}

	if (pinnedChildrenContainer) {
		newContainerStructure[container.id].components?.push(pinnedChildrenContainer.id)
		newContainerStructure[pinnedChildrenContainer.id] = pinnedChildrenContainer
	}

	annotatedChildren.forEach(
		(child) =>
			(newContainerStructure[child.structure.id] = {
				...child.structure,
				parent: !child.pinned ? relativeChildrenContainer.id : pinnedChildrenContainer?.id || '',
			})
	)

	return newContainerStructure
}

export { getSplitResponsiveContainerStructure }
